export function getBaseModelTranslation({
    modelName,
    wordClass = null,
    capitalize = false,
}) {
    const model = this.$page.props.baseModelTranslations?.[modelName]

    let result
    if (!model) {
        result = modelName
    } else {
        result = getmodelTranslation(model, wordClass)
    }

    if (capitalize) {
        return result.charAt(0).toUpperCase() + result.slice(1)
    }

    return result
}

function getmodelTranslation(model, wordClass) {
    switch (wordClass) {
        case 'DEFINITIVE':
        case 'definitive':
            return model.definitiveName
        case 'PLURAL':
        case 'plural':
            return model.pluralName
        case 'SINGULAR':
        case 'singular':
            return model.singularName
        default:
            return model.name
    }
}
